var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.645 11.207"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "return_svg__Icon_-_Bet_Return",
    "data-name": "Icon - Bet Return",
    transform: "translate(-.25 -.25)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "return_svg__Path_5676",
    "data-name": "Path 5676",
    d: "M3.877 15.379L.75 12.252l3.127-3.127",
    transform: "translate(0 -4.629)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "return_svg__Path_5677",
    "data-name": "Path 5677",
    d: "M.75 7.623h6.116A3.483 3.483 0 0010.4 4.186 3.483 3.483 0 006.866.75H3.573"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMC42NDUgMTEuMjA3Ij4KICA8ZyBpZD0iSWNvbl8tX0JldF9SZXR1cm4iIGRhdGEtbmFtZT0iSWNvbiAtIEJldCBSZXR1cm4iIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjI1IC0wLjI1KSI+CiAgICA8cGF0aCBpZD0iUGF0aF81Njc2IiBkYXRhLW5hbWU9IlBhdGggNTY3NiIgZD0iTTMuODc3LDE1LjM3OS43NSwxMi4yNTIsMy44NzcsOS4xMjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTQuNjI5KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgICA8cGF0aCBpZD0iUGF0aF81Njc3IiBkYXRhLW5hbWU9IlBhdGggNTY3NyIgZD0iTS43NSw3LjYyM0g2Ljg2NkEzLjQ4MywzLjQ4MywwLDAsMCwxMC40LDQuMTg2LDMuNDgzLDMuNDgzLDAsMCwwLDYuODY2Ljc1SDMuNTczIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgReturn as ReactComponent };